import React, { Component } from 'react';

class MultipleChoiceQuestion extends Component {
    render() {
        return (
            <React.Fragment>
                <p className="question">{this.props.question}</p>
                <div className="form" datacy="radio-buttons">
                    {this.props.options
                        ? this.props.options.map(
                              option => (
                                  <label key={option}>
                                      <input
                                          checked={this.props.userAnswer === option}
                                          onChange={() => {}}
                                          type="radio"
                                          value={option.trim()}
                                          onClick={e => this.props.onAnswerChange(e)}
                                      />
                                      {option}
                                  </label>
                              ),
                              this
                          )
                        : null}
                </div>
            </React.Fragment>
        );
    }
}

export default MultipleChoiceQuestion;



// WEBPACK FOOTER //
// ./src/components/Modal/MultipleChoiceQuestion.jsx